import React, { useState } from 'react';
import { Box } from '@mui/material';
import Services from '../Common/Services/page';
import ProductionValue from './ProductionValue';
import ProductionQuantity from './ProductionQuantity';
import IncreaseInValues from './IncreaseInValues';
import Header from '../../Common/Header/Header';
import ChartsContainer from '../../Common/ChartsContainer'; 

const renderContent = (activeIndex) => {
    switch (activeIndex) {
        case 0:
            return (
                <Services
                    module={{
                        sectionTitle: 'do Indicativo da Situação'
                    }}
                    queryConfig={{
                        key: 'production-situation-services',
                        url: 'governanceroom/dashboard/services/production/situation'
                    }}
                />
            );
        case 1:
            return <ProductionQuantity />;
        case 2:
            return <ProductionValue />;
        case 3:
            return <IncreaseInValues />;
        default:
            return null;
    }
};

const titleMap = {
    [`0`]: 'Situação de Produção',
    [`1`]: 'Produção - Quantidade',
    [`2`]: 'Produção - Valor',
    [`3`]: 'Incremento de Valores'
};

const Production = ({ setActiveIndex }) => {
    const [activeIndexLocal, setActiveIndexLocal] = useState(0);

    const handleHomeClick = () => {
        if (setActiveIndex) {
            setActiveIndex(0); 
        }
        setActiveIndexLocal(0); 
    };

    const menus = [
        {
            title: 'Situação de Produção',
            onclick: () => setActiveIndexLocal(0),
            active: activeIndexLocal === 0
        },
        {
            title: 'Produção - Quantidade',
            onclick: () => setActiveIndexLocal(1),
            active: activeIndexLocal === 1
        },
        {
            title: 'Produção - Valor',
            onclick: () => setActiveIndexLocal(2),
            active: activeIndexLocal === 2
        },
        {
            title: 'Incremento de Valores',
            onclick: () => setActiveIndexLocal(3),
            active: activeIndexLocal === 3
        }
    ];

    return (
        <Box className="producao-container">
            <Header menus={menus} onHomeClick={handleHomeClick} />
            <Box className="content">
                <ChartsContainer
                    title={titleMap[`${activeIndexLocal}`]} 
                    className={`services-container-dashboards`}
                >
                    {renderContent(activeIndexLocal)}
                </ChartsContainer>
            </Box>
        </Box>
    );
};

export default Production;